// === INIT GLOBAL ===
document.addEventListener('click', function(e) {
  const drawerBtn = e.target.closest('[data-open-cart-drawer]');
  if (drawerBtn) {
    e.preventDefault();
    openCartDrawer();
  }
});

function updateFreeShippingBar() {
  const progressBar = document.querySelector('.cart-free-shipping-bar__progress');
  const text = document.querySelector('.cart-free-shipping-bar__text');
  const configEl = document.getElementById('free-shipping-config');

  if (!progressBar || !text || !configEl) return;

  const config = JSON.parse(configEl.textContent || '{}');
  const lang = document.documentElement.lang || 'fr';

  // Vérifie si promo active
  let promoActive = false;
  if (config.enabled) {
    if (config.endDate) {
      const parts = config.endDate.split('-');
      if (parts.length === 3) {
        let day, month, year;
        if (parts[0].length === 4) {
          // format AAAA-MM-JJ
          year = parts[0];
          month = parts[1];
          day = parts[2];
        } else {
          // format JJ-MM-AAAA
          day = parts[0];
          month = parts[1];
          year = parts[2];
        }

        const isoDate = `${year}-${month}-${day}T23:59:59Z`;
        let endDateUTC = new Date(isoDate);

        const now = new Date();
        const nowParis = new Date(
          now.toLocaleString("en-US", { timeZone: "Europe/Paris" })
        );
        const endParis = new Date(
          endDateUTC.toLocaleString("en-US", { timeZone: "Europe/Paris" })
        );

        if (nowParis <= endParis) {
          promoActive = true;
        }
      }
    } else {
      promoActive = true; // pas de date → illimité
    }
  }

  if (promoActive) {
    progressBar.style.width = `100%`;
    const messages = {
      fr: `<strong>Livraison offerte !</strong> 🎉`,
      es: `<strong>¡Envío gratuito !</strong> 🎉`
    };
    text.innerHTML = messages[lang] || messages.fr;
    return;
  }

  // === Calcul normal ===
  const shippingThreshold = 20000; // 200 € en centimes
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const current = cart.total_price;
      const remaining = shippingThreshold - current;
      const progress = Math.min(current / shippingThreshold, 1);

      progressBar.style.width = `${progress * 100}%`;

      let euros = (remaining / 100).toFixed(2).replace('.', ',');
      if (euros.endsWith(',00')) euros = euros.replace(',00', '');

      let messages = {
        fr: {
          more: `Plus que <strong>${euros}€</strong> pour profiter de la livraison offerte !`,
          free: `<strong>Livraison offerte !</strong> 🎉`
        },
        es: {
          more: `¡Solo te faltan <strong>${euros}€</strong> para disfrutar del envío gratuitо!`,
          free: `<strong>¡Envío gratuito !</strong> 🎉`
        }
      };

      const t = messages[lang] || messages.fr;
      text.innerHTML = remaining > 0 ? t.more : t.free;
    });
}

// === RELOAD HEADER + TOGGLE ===
function reloadCartHeader(callback) {
  $.get(theme.routes.cart_url, function(data) {
    var cartUpdateSelector = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
    var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartUpdateSelector);

    $(cartUpdateSelector).each(function(index){
      $($newCartObj[index]).find('[data-cc-animate]').removeAttr('data-cc-animate');
      $(this).replaceWith($newCartObj[index]);
    });

    if (typeof callback === 'function') callback();
  });
}

function initCartUpsellCarousel() {
  const carousel = document.getElementById('upsell-carousel');
  const prev = document.querySelector('.cart-swiper-button-prev');
  const next = document.querySelector('.cart-swiper-button-next');
  const scrollAmount = 220;

  if (!carousel || !prev || !next) {
    console.warn("⛔ Éléments upsell non trouvés.");
    return;
  }

  function updateArrows() {
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    const currentScroll = carousel.scrollLeft;
    prev.classList.toggle('swiper-button-disabled', currentScroll <= 0);
    next.classList.toggle('swiper-button-disabled', currentScroll >= maxScroll - 5);
  }

  prev.addEventListener('click', e => {
    e.preventDefault();
    carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    updateArrows();
  });

  next.addEventListener('click', e => {
    e.preventDefault();
    carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    updateArrows();
  });

  carousel.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);
  updateArrows();
}

function hideUpsellProductsInCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const productIdsInCart = cart.items.map(item => item.product_id);
      document.querySelectorAll('.cart-upsell__item').forEach(item => {
        const id = parseInt(item.dataset.productId);
        if (productIdsInCart.includes(id)) {
          item.style.display = 'none';
        }
      });
    });
}

/* 🔹 met à jour le titre "Panier (X)" */
function updateCartTitleHeader(itemCount) {
  const headerTitle = document.querySelector('.cart-drawer__header h2');
  if (!headerTitle || typeof itemCount !== 'number') return;

  const baseTitle =
    headerTitle.dataset.baseTitle
    || headerTitle.textContent.replace(/\s*\(\d+\)\s*$/, '');

  headerTitle.dataset.baseTitle = baseTitle;
  headerTitle.textContent = `${baseTitle} (${itemCount})`;
}

/* 🔹 helper fallback qui va chercher le cart et met à jour le titre */
function updateCartTitleManually() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartTitleHeader(cart.item_count);
    });
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const drawerContent = drawer.querySelector('[data-cart-drawer-body]');
  const drawerFooter = drawer.querySelector('.cart-drawer__footer');

  drawer.classList.add('active');

  // 🔔 on émet l'event "cart-drawer:open" tout de suite
  document.dispatchEvent(new CustomEvent('cart-drawer:open'));

  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawerContent = doc.querySelector('[data-cart-drawer-body]');
      const newDrawerFooter = doc.querySelector('.cart-drawer__footer');

      if (newDrawerContent && drawerContent) {
        drawerContent.innerHTML = newDrawerContent.innerHTML;
      }
      if (newDrawerFooter && drawerFooter) {
        drawerFooter.innerHTML = newDrawerFooter.innerHTML;
      }

      attachCartDrawerListeners();
      setupCartDrawerCloseListeners();
      initCartUpsellCarousel();
      hideUpsellProductsInCart();

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateFreeShippingBar(cart.total_price);
          updateGoalBar(cart.total_price);
          updateCartTitleHeader(cart.item_count); // maj du titre "(x)" dès l'ouverture
        });

      document.body.classList.add('drawer-open');
    });
}

// === Fonctions AJAX du cart drawer ===
function reloadCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newBody = doc.querySelector('[data-cart-drawer-body]');
      const newFooter = doc.querySelector('.cart-drawer__footer');

      const currentBody = document.querySelector('[data-cart-drawer-body]');
      const currentFooter = document.querySelector('.cart-drawer__footer');

      if (newBody && currentBody) {
        currentBody.innerHTML = newBody.innerHTML;
      }

      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      attachCartDrawerListeners();
      initCartUpsellCarousel();
      setupCartDrawerCloseListeners();
      hideUpsellProductsInCart();

      // 💸 Met à jour la barre + goal bar + titre
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateFreeShippingBar(cart.total_price);
          updateGoalBar(cart.total_price);
          updateCartTitleHeader(cart.item_count); // 👈 important
        });
    });
}

function updateCartDrawerLine(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line + 1, quantity }) // Shopify = 1-based
  }).then(() => {
    reloadCartDrawer();
    hideUpsellProductsInCart();
  });
}

function attachCartDrawerListeners() {
  document.querySelectorAll('[data-action="increase"]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const container = btn.closest('.cart-quantity');
      const line = parseInt(container.dataset.line);
      const qtySpan = container.querySelector('span:not([data-action])');
      const currentQty = parseInt(qtySpan.textContent);
      updateCartDrawerLine(line, currentQty + 1);
    });
  });

  document.querySelectorAll('[data-action="decrease"]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const container = btn.closest('.cart-quantity');
      const line = parseInt(container.dataset.line);
      const qtySpan = container.querySelector('span:not([data-action])');
      const currentQty = parseInt(qtySpan.textContent);
      const newQty = Math.max(currentQty - 1, 0);
      updateCartDrawerLine(line, newQty);
    });
  });

  document.querySelectorAll('[data-action="remove"]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const line = parseInt(btn.dataset.line);
      updateCartDrawerLine(line, 0);
    });
  });
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.remove('active');
    document.body.classList.remove('drawer-open');
  }
}

function setupCartDrawerCloseListeners() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const closeBtn = drawer.querySelector('.cart-drawer__close');
  const overlay = drawer.querySelector('.cart-drawer__overlay');

  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawer);
  }

  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }
}

/* 🧲 EVENTS GLOBAUX */

// Quand ton thème (ou toi) déclenche cart:updated avec le nouveau cart
document.addEventListener('cart:updated', function(event) {
  const itemCount = event.detail?.cart?.item_count;
  updateCartTitleHeader(itemCount);
});

// essaie de s’exécuter quand le drawer s’ouvre
document.addEventListener('cart-drawer:open', updateCartTitleManually);

// au cas où : premier rendu DOM
document.addEventListener('DOMContentLoaded', updateCartTitleManually);
